import { render, staticRenderFns } from "./DragDropImage.vue?vue&type=template&id=30bcbb80&scoped=true&"
import script from "./DragDropImage.vue?vue&type=script&lang=ts&"
export * from "./DragDropImage.vue?vue&type=script&lang=ts&"
import style0 from "./DragDropImage.vue?vue&type=style&index=0&id=30bcbb80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bcbb80",
  null
  
)

export default component.exports